import { render, staticRenderFns } from "./FormInputAmountWidget.vue?vue&type=template&id=070bac9c&"
import script from "./FormInputAmountWidget.vue?vue&type=script&lang=js&"
export * from "./FormInputAmountWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports